import rivets from 'rivets';
import BaseView from '../../core/baseView';

export default BaseView.extend({
  events: {
    'change [name="payment[onlinebanktransfertype]"]': 'onRadioChange'
  },

  initialize: function() {
    /*
         Bind rivets
         */
    this.binding = rivets.bind(this.el, {
      model: this.model
    });
  },

  onRadioChange: function() {
    this.model.set({
      pfcDescriptionVisible:
        this.$('[name="payment[onlinebanktransfertype]"]:checked').val() ===
        'PFC'
    });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentPostfinanceView.js
 **/